import { render } from "./Panel.vue?vue&type=template&id=1f464a7f&scoped=true"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"

import "./Panel.vue?vue&type=style&index=0&id=1f464a7f&scoped=true&lang=css"

import exportComponent from "/Data/maps/disappearance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f464a7f"]])

export default __exports__